import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=a54d8572&scoped=true"
import script from "./repair.vue?vue&type=script&lang=js"
export * from "./repair.vue?vue&type=script&lang=js"
import style0 from "./repair.vue?vue&type=style&index=0&id=a54d8572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54d8572",
  null
  
)

export default component.exports